import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';

import Boton from '../../commons/Boton';
import CheckBox from '../../commons/CheckBox';
import Modal from '../../commons/Modal';
import Texto from '../../commons/Texto';
import Tabla from '../../commons/Tabla';
import { useFormularioContext } from '../../commons/Formulario';

import { confirmacion } from '../../commons/Mensajes';

import { testeoModel } from '../../redux/models/testeo.model';
import { testeoDetalleModel } from '../../redux/models/testeo.detalle.model';
import { servicios } from '../../redux/helpers';
import TesteoDetail from './TesteoDetail';

const TesteoItem = () => {
  const {
    selected,
    openModal,
    processing,
    errors,
    callTransaction,
    cancelTransaction,
  } = useFormularioContext();
  const [testeo, setTesteo] = useState(selected);
  const [detail, setDetail] = useState([]);
  const [modelDetail, setModelDetail] = useState(testeoDetalleModel);
  const [showDetail, setShowDetail] = useState(false);
  const { currentUser } = useSelector((state) => state.app);

  const handleChange = (item) => {
    const { name, value } = item;
    setTesteo((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    setTesteo(selected);
    setDetail(
      selected.lt.map((l) => ({ ...l, id: l.co, td: l.td.dt, de: l.td.de }))
    );
    if (!openModal) {
      setDetail([]);
    }
  }, [selected, openModal]);

  if (!openModal) {
    return null;
  }

  const handleSave = () => {
    let lt = detail.map((x) => ({ ...x, std: x.td }));

    let item = {
      ...testeo,
      ie: currentUser.ie,
      lt,
    };
    callTransaction({
      method: 'post',
      url: servicios.TESTEO,
      data: item,
      model: testeoModel,
    });
  };

  const columns = [
    {
      key: 'id',
      align: 'center',
      content: (item) => (
        <>
          {item.co && (
            <EditIcon
              style={{ color: 'green', cursor: 'pointer' }}
              onClick={() => {
                setModelDetail(item);
                setShowDetail(true);
              }}
            />
          )}
          <DeleteForeverIcon
            style={{ color: 'red', cursor: 'pointer' }}
            onClick={() =>
              confirmacion(
                '¿Deseas eliminar?',
                `Está seguro de eliminar ${item.nt} de la lista`
              )
                .then(() => handleDeleteDetail(item))
                .catch(() => {})
            }
          />
        </>
      ),
    },
    {
      key: 'nt',
      label: 'Nombre',
      content: (item) => (
        <span
          style={{
            color: `${item.st === true ? 'black' : 'red'}`,
            textDecoration: `${item.st === true ? 'none' : 'line-through'}`,
          }}
        >
          {item.nt}
        </span>
      ),
    },
    {
      key: 'de',
      label: 'Tipo dato',
      content: (item) => (
        <span
          style={{
            color: `${item.st === true ? 'black' : 'red'}`,
            textDecoration: `${item.st === true ? 'none' : 'line-through'}`,
          }}
        >
          {item.de}
        </span>
      ),
    },
  ];

  const handleAddDetail = (item) => {
    let exits = detail.find((x) => x.id === item.id);
    if (exits) {
      setDetail(
        detail.map((x) =>
          x.id === item.id
            ? { ...x, nt: item.nt, td: item.td, de: item.de, st: item.st }
            : x
        )
      );
    } else {
      item.id = new Date().getTime().toString();
      item.st = true;
      setDetail([...detail, item]);
    }
    setShowDetail(false);
  };

  const handleDeleteDetail = (item) => {
    setDetail(detail.filter((x) => x.id !== item.id));
  };

  return (
    <Modal
      title={`${testeo.te ? 'Editar testeo ' + testeo.ct : 'Nuevo testeo'}`}
      processing={processing}
      onActions={() => (
        <>
          <Boton
            className="op-dinamic"
            icon={() => <AddIcon />}
            tabIndex={22}
            style={{ '--button-color': '#3285a8' }}
            onClick={() => {
              setModelDetail(testeoDetalleModel);
              setShowDetail(true);
            }}
          >
            Agregar Testeo Unitario
          </Boton>
          <Boton
            className="op-grabar"
            disabled={processing}
            icon={() => <SaveIcon />}
            tabIndex={19}
            onClick={() =>
              confirmacion(
                '¿Desea guardar?',
                `${
                  testeo.te
                    ? 'Una actualización del testeo' + testeo.ct
                    : 'Un nuevo testeo'
                }`
              )
                .then(() => handleSave())
                .catch(() => {})
            }
          >
            Guardar
          </Boton>
        </>
      )}
      onClose={() => cancelTransaction(testeoModel)}
    >
      {testeo.te === null && (
        <Texto
          name="ct"
          value={testeo.ct}
          label="C&oacute;digo"
          tabIndex={10}
          size={2}
          error={errors.ct}
          onChange={handleChange}
          disabled={testeo.gc}
        />
      )}
      <Texto
        name="nt"
        value={testeo.nt}
        label="Nombre"
        size={2}
        tabIndex={11}
        error={errors.nt}
        onChange={handleChange}
      />
      {testeo.te ? (
        <div className="op-form-group op-col-2 op-checkbox-group">
          <span>Estado del registro</span>
          <CheckBox
            name="st"
            tabIndex={12}
            checked={testeo.st}
            onChange={handleChange}
          />
        </div>
      ) : (
        <div className="op-form-group op-col-2 op-checkbox-group">
          <span>¿Desea autogenerar el c&oacute;digo?</span>
          <CheckBox
            name="gc"
            tabIndex={13}
            checked={testeo.gc}
            onChange={handleChange}
          />
        </div>
      )}
      <Texto
        name="dt"
        value={testeo.dt}
        label="Descripci&oacute;n"
        tabIndex={14}
        error={errors.dt}
        onChange={handleChange}
      />
      <div className="op-form-group op-col-1">
        <div className="op-table" style={{ padding: 0, flexBasis: '100%' }}>
          <Tabla
            columns={columns}
            data={detail}
            searcheable={false}
            pagination={false}
            hoverSelectedRow={false}
            emptyRowsMessage="Ning&uacute;n testeo unitario asignado"
          />
        </div>
        {showDetail && (
          <TesteoDetail
            selected={modelDetail}
            onSend={handleAddDetail}
            onClose={() => setShowDetail(false)}
          />
        )}
      </div>
    </Modal>
  );
};

export default TesteoItem;
